import { EChartsOption } from "echarts";
export const graph_sensor: EChartsOption = {
  title: {
    text: "Comportamiento de alimentacion"
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow"
    }
  },
  legend: {
    show: true,
    data: ["Kg dieta real", "Kg ajustados"]
  },
  toolbox: {
    show: true,
    feature: {
      dataView: { show: true, readOnly: false },
      dataZoom: { show: true },
      restore: { show: true },
      magicType: { show: true, type: ["line", "bar"] },
      saveAsImage: { show: true }
    }
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    // prettier-ignore
    data: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00']
  },
  yAxis: {
    type: "value",
    axisLabel: {
      formatter: "{value} Kg."
    },
    axisPointer: {
      snap: true
    }
  },
  visualMap: {
    show: false,
    dimension: 0,
    pieces: [
      {
        lte: 6,
        color: "green"
      },
      {
        gt: 6,
        lte: 8,
        color: "red"
      },
      {
        gt: 8,
        lte: 14,
        color: "green"
      },
      {
        gt: 14,
        lte: 17,
        color: "red"
      },
      {
        gt: 17,
        color: "green"
      }
    ]
  },
  series: [
    {
      name: "",
      type: "line",
      smooth: true,
      data: [],
      markArea: {
        itemStyle: {
          color: "rgba(255, 173, 177, 0.4)"
        },
        data: [
          [
            {
              name: "Alerta de alimento",
              xAxis: 6
            },
            {
              xAxis: 8
            }
          ],
          [
            {
              name: "Alerta de alimento",
              xAxis: 9
            },
            {
              xAxis: 10
            }
          ]
        ]
      }
    },
    {
      name: "Kg dieta real",
      type: "line",
      smooth: true,
      data: [],
      color: "#30646c"
    },
    {
      name: "Kg ajustados",
      type: "line",
      smooth: true,
      data: [],
      color: "#FF0000"
    }
  ]
};
